import React from "react";

export default function ColorFrame34({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#643C5A"
          d="M61.461 73.068c0-8.878 7.197-16.075 16.075-16.075h76.722c9.685 0 17.536 7.851 17.536 17.536v181.939c0 5.65-4.58 10.23-10.229 10.23H71.691c-5.65 0-10.23-4.58-10.23-10.23v-183.4z"
        ></path>
        <ellipse
          cx="74.614"
          cy="257.564"
          fill="#643C5A"
          rx="13.152"
          ry="12.056"
        ></ellipse>
        <ellipse
          cx="102.379"
          cy="257.564"
          fill="#643C5A"
          rx="13.152"
          ry="12.056"
        ></ellipse>
        <ellipse
          cx="130.876"
          cy="257.564"
          fill="#643C5A"
          rx="13.152"
          ry="12.056"
        ></ellipse>
        <ellipse
          cx="158.642"
          cy="257.564"
          fill="#643C5A"
          rx="13.152"
          ry="12.056"
        ></ellipse>
        <path
          fill="#643C5A"
          d="M171.794 72.893c0 8.167-24.699 14.789-55.166 14.789-30.468 0-55.167-6.622-55.167-14.79-1.096-9.688 24.7-52.433 55.167-52.433 30.467 0 55.166 44.266 55.166 52.434z"
        ></path>
        <rect
          width="19"
          height="14"
          x="107"
          y="13"
          fill="#643C5A"
          rx="2.923"
        ></rect>
        <rect
          width="23"
          height="18"
          x="105"
          y="1"
          fill="#EA2F2F"
          rx="2.923"
        ></rect>
        <rect
          width="113.255"
          height="110.333"
          x="60"
          y="92.796"
          fill="#EA2F2F"
          rx="2.923"
        ></rect>
        <rect
          width="93.911"
          height="93.911"
          x="69.307"
          y="101.373"
          fill="#fff"
          stroke="#F36F56"
          strokeWidth="4"
          rx="46.956"
        ></rect>
        <path
          fill="#7C4E71"
          d="M162.818 176.289c.599-1.564 2.122-2.516 3.797-2.516h37.732c1.921 0 3.615 1.245 4.118 3.099 1.396 5.14 3.899 15.564 3.417 22.664-.662 9.748-7.284 29.592-7.946 37.6-.491 5.946 1.755 23.793 2.944 32.589.358 2.648-1.697 5.011-4.37 5.011h-32.971c-2.867 0-4.979-2.705-4.342-5.499 1.981-8.69 5.322-25.307 3.647-32.101-2.317-9.4-7.614-24.023-9.269-37.6-1.203-9.863 1.612-18.99 3.243-23.247z"
        ></path>
        <mask
          id="mask0_2256_161652"
          style={{ maskType: "alpha" }}
          width="53"
          height="102"
          x="159"
          y="173"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#6A4B62"
            d="M162.818 176.289c.599-1.564 2.122-2.516 3.797-2.516h37.732c1.921 0 3.615 1.245 4.118 3.099 1.396 5.14 3.899 15.564 3.417 22.664-.662 9.748-7.284 29.592-7.946 37.6-.491 5.946 1.755 23.793 2.944 32.589.358 2.648-1.697 5.011-4.37 5.011h-32.971c-2.867 0-4.979-2.705-4.342-5.499 1.981-8.69 5.322-25.307 3.647-32.101-2.317-9.4-7.614-24.023-9.269-37.6-1.203-9.863 1.612-18.99 3.243-23.247z"
          ></path>
        </mask>
        <g mask="url(#mask0_2256_161652)">
          <path
            fill="#EED9E9"
            d="M205.019 165.295h-39.038c-1.33 0-2.583.597-3.345 1.686-2.39 3.415-7.481 11.577-8.468 20.367-.322 2.862 2.643 4.7 5.426 3.961 2.705-.72 6.194-1.453 9.929-1.736 5.211-.396 10.757.422 14.993 1.485 8.151 2.046 21.55 1.052 27.899.406 2.073-.211 3.673-1.907 3.423-3.975-.866-7.149-4.988-15.895-7.062-19.942-.721-1.407-2.176-2.252-3.757-2.252z"
          ></path>
          <path
            fill="#643C5A"
            d="M214.656 294.61c-1.156-7.707-6.72-16.877-8.838-20.149a3.752 3.752 0 00-2.259-1.625c-2.695-.666-9.038-1.953-17.823-1.953-9.166 0-15.674 1.401-18.153 2.036a3.595 3.595 0 00-1.863 1.17c-2.201 2.612-8.54 10.827-9.853 20.226-.405 2.902 2.637 4.771 5.463 3.996 2.53-.695 5.718-1.382 9.119-1.656 4.981-.401 10.282.428 14.331 1.506 7.733 2.057 20.407 1.08 26.531.425 2.064-.221 3.653-1.923 3.345-3.976z"
          ></path>
        </g>
        <mask
          id="mask1_2256_161652"
          style={{ maskType: "alpha" }}
          width="62"
          height="28"
          x="154"
          y="165"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#7D4C71"
            d="M205.02 165.295h-39.039c-1.329 0-2.582.597-3.345 1.686-2.39 3.415-7.481 11.576-8.468 20.367-.321 2.862 2.643 4.7 5.426 3.96 2.706-.719 6.195-1.452 9.929-1.735 5.212-.396 10.757.422 14.994 1.485 8.15 2.046 21.549 1.052 27.899.406 2.072-.211 3.673-1.907 3.422-3.975-.866-7.149-4.987-15.896-7.062-19.942-.721-1.407-2.175-2.252-3.756-2.252z"
          ></path>
        </mask>
        <g fill="#DBB7D3" mask="url(#mask1_2256_161652)">
          <rect
            width="9.585"
            height="9.253"
            rx="0.731"
            transform="matrix(.89813 .43973 -.40343 .91501 170.996 183.791)"
          ></rect>
          <rect
            width="9.529"
            height="9.303"
            rx="0.731"
            transform="matrix(-.9606 .27792 .25212 .9677 189.171 186.318)"
          ></rect>
          <rect
            width="9.505"
            height="9.325"
            rx="0.731"
            transform="matrix(.98673 .16235 -.14657 .9892 198.15 188.416)"
          ></rect>
        </g>
        <rect
          width="3.989"
          height="36.223"
          x="191.199"
          y="156.046"
          fill="#F36F56"
          rx="0.731"
        ></rect>
        <rect
          width="3.414"
          height="15.011"
          fill="#F36F56"
          rx="0.731"
          transform="matrix(.73634 .67661 -.70166 .71251 201.731 146.027)"
        ></rect>
        <path
          fill="#FEA695"
          d="M191.199 173.773H195.18800000000002V192.26999999999998H191.199z"
        ></path>
        {children}
      </g>
    </svg>
  );
}
